// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1941K","colBig":"styles_colBig__2H27F","colSmall":"styles_colSmall__1QkOK"};